export const indexAdminsPath: string = "/admins";
export const newAdminsPath: string = "/admins/new";
export const editAdminsPath: string = "/admins/:id/edit"
export const editAdminsPathCreator = (id: number|string): string => `/admins/${id}/edit`